import _ from 'lodash'
import {
  FETCH_LISTINOS,
  FETCH_LISTINO,
  DELETE_LISTINO,
  SET_SELECTED_CONTACT,
  CLEAR_EXPORT_FIELDS
} from 'constants/actionTypes'

const INIT_STATE = {
  data: [],
  current: {},
  selectedContact: null,
  addresses: []
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_LISTINOS:
      let response = action.payload.data
      return {
        ...state,
        data: response
      }
    case FETCH_LISTINO:
      response = action.payload.data
      return { ...state, current: response }
    case SET_SELECTED_CONTACT:
      return { ...state, selectedContact: action.payload.rowData[0], addresses: action.payload.addresses }
    case CLEAR_EXPORT_FIELDS:
      return { ...state, selectedContact: null }
    case DELETE_LISTINO:
      return { ...state, data: _.reject(state.data, { id: action.payload }) }
    default:
      return { ...state }
  }
}



// WEBPACK FOOTER //
// ./reducers/listinos.js